<div class="tabs" role="tablist">
  @for (tab of tabs(); track tab.id; let last = $last) {
    @let selected = active()?.id === tab.id;
    <button
      type="button"
      role="tab"
      class="{{ selected ? 'active' : '' }}"
      [attr.aria-selected]="selected"
      (click)="active.set(tab)">
      {{ tab.label | translate }}
    </button>
  }
</div>
